import { render, staticRenderFns } from "./option-row.vue?vue&type=template&id=4e244476&scoped=true&"
import script from "./option-row.vue?vue&type=script&lang=js&"
export * from "./option-row.vue?vue&type=script&lang=js&"
import style0 from "./option-row.vue?vue&type=style&index=0&id=4e244476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e244476",
  null
  
)

export default component.exports